var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CollapsibleCard',{attrs:{"value":true,"collapsibleIcon":"mdi-upload","collapsibleTitle":"Vedlegg","padding":true},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('Attachments',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }